// extracted by mini-css-extract-plugin
export default {"info":"KaY8lQUkGkkrLq47JIrJ"};